import React from "react";
import { Text, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ClasswizeModal } from "./ui/Modal";
import { colours } from "@/utils/themeUtils";

interface Props {
	isOpen: boolean;
	onClose: () => void;

	focusName?: string;
	handleConfirmation: () => void;
}

export function ConfirmEndFocusModal(props: Props): JSX.Element {
	const { t } = useTranslation();
	const focusQuoted = props.focusName ? `"${props.focusName}" ` : "";
	return (
		<ClasswizeModal
			isOpen={props.isOpen}
			onClose={props.onClose}
			size={"lg"}
			title={t("confirmEndFocus.title")}
			dataTestId={"end-focus-modal"}
		>
			<ModalBody>
				<Text color={"#42526E"} lineHeight={"20px"}>
					{t("confirmEndFocus.paragraph1", { focusQuoted })}
				</Text>
				<Text fontWeight={500} color={colours.text.body} mt={8}>
					{t("confirmEndFocus.paragraph2", { focusQuoted })}
				</Text>
			</ModalBody>
			<ModalFooter>
				<Button
					float={"right"}
					onClick={() => {
						props.handleConfirmation();
						props.onClose();
					}}
				>
					{t("confirmEndFocus.confirmButton")}
				</Button>
			</ModalFooter>
		</ClasswizeModal>
	);
}
